import { render } from "./LoanNotes.vue?vue&type=template&id=03d2b4ec"
import script from "./LoanNotes.vue?vue&type=script&lang=js"
export * from "./LoanNotes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__